import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 text-[12px] font-[600] font-[Figtree,_sans-serif]" data-id="element-67">
          "Recursos visuales y adaptados para alumnos neurodivergentes y
          distintos ritmos de aprendizaje"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-68">
          <span className="px-2 text-[#F9327E] bg-[#FFFFFF] text-[24px]" data-id="element-69">
            MEGAPACK INCLUSIÓN EDUCATIVA
          </span>
        </h1>

        <h2 className="md:text-2xl font-extrabold mb-3 text-gray-800 text-[16px]" data-id="element-70">
          Material diseñado especialmente para docentes que trabajan inclusión
          educativa real y necesitan recursos más claros, accesibles y posibles
          para distintos perfiles de aprendizaje.
        </h2>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-71">
          <img src="https://cdn.magicpatterns.com/uploads/6StH4fvB71N27f4GFRSpio/mockup_pincipal.png" alt="Megapack Inclusión Educativa" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-72" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-73">
          <p className="text-[14px]" data-id="element-74">
            Actividades listas para imprimir y usar en el aula.
          </p>
        </div>

        <div className="bg-blue-50 rounded-2xl p-5 max-w-md mx-auto border border-blue-100" data-id="element-75">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-76">
            👉 Beneficios del material
          </p>
          <div className="space-y-2 text-left" data-id="element-77">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-78">
              <span className="text-green-600 mr-2 text-lg" data-id="element-79">✔️</span> Menor
              sobrecarga visual
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-80">
              <span className="text-green-600 mr-2 text-lg" data-id="element-81">✔️</span>{' '}
              Actividades simples y graduales
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-82">
              <span className="text-green-600 mr-2 text-lg" data-id="element-83">✔️</span> Diseño
              accesible y recursos multinivel
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-84">
              <span className="text-green-600 mr-2 text-lg" data-id="element-85">✔️</span> Más
              participación y comprensión
            </p>
          </div>
        </div>
      </div>
    </section>;
}